import { FC } from "react";
import { components } from "react-select";
import styled from "styled-components";
import { alpha } from "../../../typography";
import { SelectComponentProps } from "./types";

const StyledInput = styled.div`
  height: 16px;
  div {
    margin: 0px;
    padding: 0px;
  }
  input {
    ${alpha.primaryActive.body3};
  }
`;

type InputProps = SelectComponentProps["Input"];

export const Input: FC<InputProps> = (props) => (
  <StyledInput>
    <components.Input {...props} />
  </StyledInput>
);
